import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "@/components/ui/library/card";
import PrefrenceFormRenderer from "@/components/ui/others/PrefrenceRenderers/PrefrenceFormRenderer";
import { course_spesific_key } from "@/config/endpoints";
import { useCourseForm } from "@/features/universityAndCourse/contexts/FormCourseContext";

export default function CoursePrefrenceRenderer() {
  // Intake* SELECTOR(s) are rendered in Fees & Intakes as a multi-select (`IntakeSelector`).
  // Hide them here so the same `customInputScopes` index is not also bound to a single `Select`.
  const removeKeys = ["intakes", "intake month", "intake"];
  return (
    <Card className="bg-white border-[#e6e8e7] w-full gap-4 p-4 pl-6">
      <CardHeader className="px-0 py-0 gap-0">
        <CardTitle className="font-medium text-base text-black tracking-[-0.32px]">
          Course Prefrences
        </CardTitle>
      </CardHeader>

      <CardContent className="px-0 py-0">
        <PrefrenceFormRenderer
          hook={useCourseForm}
          queryKey={course_spesific_key}
          modelName="course"
          removeKeys={removeKeys}
          hideIfNameStartsWith="intake"
        />
      </CardContent>
    </Card>
  );
}
